// extracted by mini-css-extract-plugin
export default {"numberCircle":"indicator_number_numberCircle__8yFEh"};